import { render } from "./SliderFormModal.vue?vue&type=template&id=fc2b26a0&scoped=true"
import script from "./SliderFormModal.vue?vue&type=script&lang=js"
export * from "./SliderFormModal.vue?vue&type=script&lang=js"

import "./SliderFormModal.vue?vue&type=style&index=0&id=fc2b26a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc2b26a0"]])

export default __exports__